// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Button} from '../button/Button'
import {Icon} from '../icon/Icon'
import {Input} from "../input/Input";

// Polyfill
if ((window as any).Element && !Element.prototype.closest) {
    Element.prototype.closest = function (s) {

        var matches = ((this as any).document || (this as any).ownerDocument).querySelectorAll(s),
            i,
            el = (this as any);
        do {
            i = matches.length;
            while (--i >= 0 && matches.item(i) !== el) { };
        } while ((i < 0) && (el = el.parentElement));
        return el;
    };
}

@Component({
    name: 'Form',
    components: {
        Button,
        Icon
    },
    mixins: [
        template,
    ]
})
export class Form extends Vue {

    public classes: string[] = []

    public steps: Vue[] = []
    public currentStep: number | null = null
    public stepWalk: boolean = false

    public $refs!: {
        form_tour_toolbar: HTMLElement
    }

    @Prop({default: false})
    public tour!: boolean

    @Watch('tour')
    public watchTour(tour) {

        this.$nextTick(() => {

            if (tour) {
                document.addEventListener('keydown', this.handleTourArrowNavigation)

                this.findSteps()

                if (this.steps.length > 0) {
                    this.stepWalk = true
                    this.updateFormTourUI()
                } else {
                    this.stepWalk = false
                    this.$emit('update:tour', false)
                }
            } else {
                document.removeEventListener('keydown', this.handleTourArrowNavigation)

                this.stepWalk = false

                if (this.currentStep && this.steps[this.currentStep]) {
                    this.steps[this.currentStep].$data.isFormTourCurrentStep = false
                }
            }
        })
    }

    public created () {
        this.$on('submitForm', this.handleSubmit)
    }

    public mounted() {

        this.$nextTick(() => {
            
            if (this.tour) {

                document.addEventListener('keydown', this.handleTourArrowNavigation)

                this.findSteps()

                if (this.steps.length > 0) {
                    this.stepWalk = true
                    this.updateFormTourUI()
                }
            }
        })
    }

    public destroyed() {
        document.removeEventListener('keydown', this.handleTourArrowNavigation)

        this.$off('submitForm', this.handleSubmit)
    }

    public handleSubmit(e) {
        this.$emit('submit', e)
    }


    /**
     * Gibt die Aktuellen Formulardaten als Array zurück ( inmput-name => data )
     *
     * @returns {string[]}
     */
    public getDataArray()
    {
        var inputChilds: Vue[] = [];

        this.findInputs(this.$children, inputChilds)

        var data: any = {};
        inputChilds.forEach((children) => {
            data[children.$props.name] = children.$props.value
        })
        return data;
    }

    public findInputs(childrens: Vue[] = [], inputChilds: Vue[] = []) {

        childrens.forEach((children) => {

            if(['CheckboxGroup',
                'RadioGroup',
                'Input',
                'Textarea',
                'Texteditor',
                'FileInput',
                'InputList',
                'InputListMultiple',
                'AbhVerkaufteEinheiten',
                'AbhAufUmbauarten',
                'Select'].includes(children.$options.name!)) {

                inputChilds.push(children)
            }

            if (children.$children) {
                this.findInputs(children.$children, inputChilds)
            }
        })
    }

    public handleTourArrowNavigation(e: KeyboardEvent) {

        const code = e.keyCode

        if (code == 40 ) {

            e.preventDefault()

            this.nextFormTourStep()
        } else if (code == 27) {

            e.preventDefault()

            this.handleExitFormTour()
        }
    }

    public findSteps() {

        this.steps = []

        this.loopChildrens(this.$children)

        if (this.steps.length > 0) {

            this.steps[0].$data.isFormTourCurrentStep = true
            this.currentStep = 0
        }
    }

    public loopChildrens(children: Vue[] = [], parentNames: string[] = []) {

        children.forEach((child) => {
            if(['Checkbox',
                'CheckboxGroup',
                'RadioGroup',
                'Input',
                'Textarea',
                'Texteditor',
                'FileInput',
                'InputList',
                'InputListMultiple',
                'AbhVerkaufteEinheiten',
                'AbhAufUmbauarten',
                'Select'].includes(child.$options.name!)) {

                const inputErrors = child.$props.displayErrors.filter(error => error != '' && error != undefined && error != null)

                if (inputErrors.length > 0) {
                    let isCheckboxInsideCheckboxGroup = (child.$options.name! === 'Checkbox' && parentNames.includes('CheckboxGroup'))

                    if (!isCheckboxInsideCheckboxGroup) {
                        this.steps.push(child)
                    }
                }
            }

            if (child.$children) {
                this.loopChildrens(child.$children, [...parentNames, child.$options.name!])
            }
        })
    }

    public nextFormTourStep() {

        const prevStep = this.currentStep!

        if (prevStep == this.steps.length - 1) {
            return
        }

        this.currentStep = prevStep + 1

        this.updateFormTourUI(prevStep)
    }

    public updateFormTourUI(prevStep?: number) {

        if (prevStep !== undefined) {
            const prevStepComponent = this.steps[prevStep]
            prevStepComponent.$data.isFormTourCurrentStep = false
        }

        const currentStepComponent = this.steps[this.currentStep!]
        const formTourToolbarEl = this.$refs.form_tour_toolbar

        this.$nextTick(() => {

            const currentFormTourPointElement = <any>currentStepComponent.$el.closest(`.${this.$appPrefix}-form-tour-point`)

            window.scrollTo(0, this.findPosY(currentFormTourPointElement) - 155)

            currentStepComponent.$data.isFormTourCurrentStep = true

            const top = currentFormTourPointElement.getBoundingClientRect().top - this.$el.getBoundingClientRect().top

            formTourToolbarEl.style.top = (top - 55) + 'px'
            formTourToolbarEl.style.left = 0 + 'px'
        })
    }

    public handleExitFormTour() {

        this.steps[this.currentStep!].$data.isFormTourCurrentStep = false
        this.stepWalk = false
        this.$emit('update:tour', false)
    }

    public findPosY (el: any): any {

        let curtop = 0

        if (el.offsetParent) {

            do {
                curtop += el.offsetTop
            } while (el = el.offsetParent)

            return curtop
        }
    }
}